import React, {Fragment} from "react"
import PropTypes from "prop-types"

import {Para} from "@irati/ui/src/Labels"

import {isScheduleEnabled} from "../../../helpers/schedule"
import {TeamNamesSummary, NextTriggerAtSummary, WeekPeriodSummary} from "../../../components/Schedule"


const ScheduleSummary = ({schedule}) => {
  const isEnabled = isScheduleEnabled(schedule)

  return (
    <Fragment>
      {!isEnabled && (
        <Para>
          <span>We&apos;ll send {schedule.preferences.questionCount} </span>
          {schedule.preferences.questionCount < 10 && <span>quick </span>}
          <span>questions every </span>
          {schedule.periodValue === 1 && (
            <span>week, great for an up-to-date view of the health of your organisation. </span>
          )}
          {schedule.periodValue === 2 && <span>two weeks. </span>}
          {schedule.periodValue === 4 && <span>four weeks. </span>}
          <span>We&apos;ll always send your surveys at 2.00pm as we typically find there&apos;s a higher
        response rate in the afternoon.</span>
        </Para>
      )}

      {isEnabled && (
        <Fragment>
          <Para>
            <span>Your pulse survey will be sent </span>
            <strong>
              <span>every </span>
              <span><WeekPeriodSummary schedule={schedule} /> </span>
            </strong>
            <span>to </span>
            <strong><TeamNamesSummary schedule={schedule} />.</strong>
          </Para>
          <NextTriggerAtSummary schedule={schedule} />
        </Fragment>
      )}
    </Fragment>
  )
}


ScheduleSummary.propTypes = {
  schedule: PropTypes.object
}

ScheduleSummary.defaultProps = {
  schedule: {}
}

export default ScheduleSummary
